/* eslint-disable react/display-name */
import PropTypes from 'prop-types';
import { Link } from 'gatsby-plugin-react-i18next';
import TestingDetailsContent from '../testingDetailsContent';
import { renderRichText } from 'gatsby-source-contentful/rich-text';
import { BLOCKS } from '@contentful/rich-text-types';

const options = {
	renderNode: {
		[BLOCKS.PARAGRAPH]: (node, children) => {
			return (
				<p className="typography typography--body typography--white">
					{children}
				</p>
			);
		},
	},
};

const TestingsDetails = ({
	testCategories,
	title,
	subtitle,
	bottomTitle,
	bottomText,
	actions,
	disclaimers,
}) => {
	return (
		<div id="testing-details" className="testing-details">
			<div className="testing-details__content">
				<div className="testing-details__body">
					<div className="testing-details__head">
						<h2 className="typography typography--h1 typography--white">
							{title}
						</h2>
						<p className="typography typography--subtle-big typography--white">
							{subtitle}
						</p>
					</div>
					{testCategories ? <TestingDetailsContent rows={testCategories} />: null}
					{disclaimers ? <div>{renderRichText(disclaimers, options)}</div>: null}
					<div className="testing-details__copy">
						<h3 className="typography typography--h3 typography--white">
							{bottomTitle}
						</h3>
						<p className="typography typography--body typography--white">
							{bottomText}
						</p>
						<div>
							{actions?.map((acc, index) => {
								const { title, link } = acc;
								return (
									<Link
										key={index}
										className="btn btn--off-white-outlined btn--travel"
										to={link}
									>
										{title}
									</Link>
								);
							})}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

TestingsDetails.propTypes = {
	testCategories: PropTypes.any,
	title: PropTypes.string.isRequired,
	subtitle: PropTypes.string.isRequired,
	bottomTitle: PropTypes.string.isRequired,
	bottomText: PropTypes.string.isRequired,
	actions: PropTypes.arrayOf(
		PropTypes.shape({
			link: PropTypes.string,
			title: PropTypes.string,
		})
	),
	disclaimers: PropTypes.shape({
		raw: PropTypes.string,
	}).isRequired,
};

export default TestingsDetails;
